import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";
import AppConfig from "../../../config/AppConfig";
import standardEventCover from "../../../img/coriandoli.png";

export class UserEventItem extends React.Component {
    constructor(props) {
        super(props);
        this.coverStyle = {
            minHeight: "160px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
        };
        this.coverOverlayStyle = {
            minHeight: "160px",
            background: "linear-gradient(180deg, rgba(0,0,0,.08) 0%, rgba(0,0,0,.72) 100%)",
        };
        this.iconBoxStyle = {
            width: "34px",
            minWidth: "34px",
            height: "34px",
        };
    }

    handleEventClick = _ => {
        this.props.onClick(this.props.item.event_id, this.props.item.event_type);
    }

    render() {
        const item = this.props.item || {};

        const imageUrl = item.image_url ?
            item.image_url.indexOf("http") === 0 ?
                item.image_url :
                `${AppConfig.webServerUrl}${item.image_url.indexOf("/") === 0 ? item.image_url : `/${item.image_url}`}` :
            standardEventCover;

        const coverStyle = {
            ...this.coverStyle,
            backgroundImage: `url(${imageUrl})`,
        };

        const participantsText = !Number.isNaN(item.expected_participants) && item.expected_participants > 0 ?
            `${item.confirmed_participants || 0} / ${item.expected_participants} confermati` :
            `${item.confirmed_participants || 0} confermati`;

        return (
            <li className={"list-group-item border-0 p-0 mb-3 bg-transparent"} onClick={this.handleEventClick}>
                <div className={"card border-0 shadow-sm overflow-hidden"}>
                    <div style={coverStyle}>
                        <div className={"d-flex flex-column justify-content-between p-3 text-white"}
                             style={this.coverOverlayStyle}>
                            <div>
                                {
                                    parseInt(item.pending_participants || 0, 10) > 0 &&
                                    <div className={"d-flex justify-content-end mb-2"}>
                                        <span className={"badge badge-warning font-weight-bold shadow-sm"}>
                                            {item.pending_participants} in attesa
                                        </span>
                                    </div>
                                }
                                <h5 className={"font-weight-bold mb-1"}>{item.name}</h5>
                                <div className={"small"}>
                                    <span>
                                        <FaRegularIcon name={"calendar"} className={"mr-1"}/>
                                        {moment(item.start_date).format("DD MMM YYYY")}
                                    </span>
                                    {
                                        item.location_name &&
                                        <span className={"ml-2"}>
                                            <FaSolidIcon name={"map-marker-alt"} className={"mr-1"}/> {item.location_name || ""}
                                        </span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card-body py-3"}>
                        <div className={"d-flex align-items-center justify-content-between"}>
                            <div className={"d-flex align-items-center text-muted small mr-3"}>
                                <div
                                    className={"rounded bg-light d-flex align-items-center justify-content-center text-primary mr-2"}
                                    style={this.iconBoxStyle}
                                >
                                    <FaSolidIcon name={"user-check"}/>
                                </div>
                                <span>{participantsText}</span>
                            </div>
                            <button type={"button"}
                                    className={"btn btn-sm btn-light text-primary font-weight-bold rounded-pill"}>
                                <FaSolidIcon name={"share-alt"} className={"mr-1"}/>
                                Condividi
                            </button>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

UserEventItem.propTypes = {
    item: PropTypes.object,
    onClick: PropTypes.func,
};
